import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  vendorAccounting: { loading: false, data: [], error: null },
  dealerAccounting: { loading: false, data: [], error: null },
  oilAudit: { loading: false, data: [], error: null },
  heaterDraw: { loading: false, data: [], error: null },
};

const reportingSlice = createSlice({
  name: "afmsReporting",
  initialState,
  reducers: {
    // Vendor Accounting
    vendorAccountingStart: (state) => {
      state.vendorAccounting.loading = true;
      state.vendorAccounting.error = null;
    },
    vendorAccountingSuccess: (state, action) => {
      state.vendorAccounting.loading = false;
      state.vendorAccounting.data = action.payload;
      state.vendorAccounting.error = null;
    },
    vendorAccountingFailure: (state, action) => {
      state.vendorAccounting.loading = false;
      state.vendorAccounting.error = action.payload;
    },
    vendorAccountingReset: (state) => {
      state.vendorAccounting = initialState.vendorAccounting;
    },

    // Dealer Accounting
    dealerAccountingStart: (state) => {
      state.dealerAccounting.loading = true;
      state.dealerAccounting.error = null;
    },
    dealerAccountingSuccess: (state, action) => {
      state.dealerAccounting.loading = false;
      state.dealerAccounting.data = action.payload;
      state.dealerAccounting.error = null;
    },
    dealerAccountingFailure: (state, action) => {
      state.dealerAccounting.loading = false;
      state.dealerAccounting.error = action.payload;
    },
    dealerAccountingReset: (state) => {
      state.dealerAccounting = initialState.dealerAccounting;
    },

    // Oil Audit
    oilAuditStart: (state) => {
      state.oilAudit.loading = true;
      state.oilAudit.error = null;
    },
    oilAuditSuccess: (state, action) => {
      state.oilAudit.loading = false;
      state.oilAudit.data = action.payload;
      state.oilAudit.error = null;
    },
    oilAuditFailure: (state, action) => {
      state.oilAudit.loading = false;
      state.oilAudit.error = action.payload;
    },
    oilAuditReset: (state) => {
      state.oilAudit = initialState.oilAudit;
    },

    // Heater Draw
    heaterDrawStart: (state) => {
      state.heaterDraw.loading = true;
      state.heaterDraw.error = null;
    },
    heaterDrawSuccess: (state, action) => {
      state.heaterDraw.loading = false;
      state.heaterDraw.data = action.payload;
      state.heaterDraw.error = null;
    },
    heaterDrawFailure: (state, action) => {
      state.heaterDraw.loading = false;
      state.heaterDraw.error = action.payload;
    },
    heaterDrawReset: (state) => {
      state.heaterDraw = initialState.heaterDraw;
    },
  },
});

export const {
  vendorAccountingStart,
  vendorAccountingSuccess,
  vendorAccountingFailure,
  vendorAccountingReset,
  dealerAccountingStart,
  dealerAccountingSuccess,
  dealerAccountingFailure,
  dealerAccountingReset,
  oilAuditStart,
  oilAuditSuccess,
  oilAuditFailure,
  oilAuditReset,
  heaterDrawStart,
  heaterDrawSuccess,
  heaterDrawFailure,
  heaterDrawReset,
} = reportingSlice.actions;

export default reportingSlice.reducer;
